import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { user } from 'services/user';
import { CallsWidget } from './calls-widget';
import { AlarmsWidget } from './alarms-widget';
import { GrzWidget } from './grz-widget';
import { SummaryWidget } from './summary-widget';
import { OccupancyWidget } from './occupancy-widget';
import { HealthWidget } from './health-widget';
import { Dock, DockHead, DockToggle, Stack } from './widgets-dock.styled';
import { CaretIcon } from './icons';
import { sortWidgetDefs } from './defs';

const COMPONENTS = { calls: CallsWidget, alarms: AlarmsWidget, grz: GrzWidget, summary: SummaryWidget, occ: OccupancyWidget, health: HealthWidget };

const LS_KEY = 'dock_state_v1';

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || '{}') || {};
  } catch (e) {
    return {};
  }
};
const save = (state) => {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(state));
  } catch (e) {
    /* private mode / disabled storage — ignore */
  }
};

export const WidgetsDock = () => {
  const { t } = useTranslation();
  const [state, setState] = useState(load);

  // default: panel and every widget open
  const panelOpen = state.panel !== false;
  const isOpen = (k) => state[k] !== false;

  const update = (patch) => {
    setState((prev) => {
      const next = { ...prev, ...patch };
      save(next);
      return next;
    });
  };

  const toggle = (k) => update({ [k]: state[k] === false });
  const togglePanel = () => update({ panel: state.panel === false });

  // ГРЗ-виджет — только если на объекте включён контроль ГРЗ
  const grzEnabled = user.getInterfaceParam('vehicle_plate_control') !== false;

  // скрытые пользователем виджеты (Настройки → Виджеты)
  const hiddenWidgets = useSelector((store) => store.widgets.hiddenWidgets, shallowEqual) || [];
  const widgetsOrder = useSelector((store) => store.widgets.widgetsOrder, shallowEqual) || [];
  const visible = (k) => hiddenWidgets.indexOf(k) === -1;

  return (
    <Dock>
      <DockHead style={{ justifyContent: 'flex-end' }}>
        <DockToggle type="button" onClick={togglePanel}>
          <span style={{ display: 'inline-flex', transform: panelOpen ? 'none' : 'rotate(180deg)', transition: 'transform .18s ease' }}>
            <CaretIcon />
          </span>
          {panelOpen ? t('dock.Свернуть') : t('dock.Развернуть')}
        </DockToggle>
      </DockHead>

      {panelOpen && (
        <Stack>
          {sortWidgetDefs(widgetsOrder).map((w) => {
            const Widget = COMPONENTS[w.key];
            if (!Widget || !visible(w.key) || (w.grzOnly && !grzEnabled)) {
              return null;
            }
            return <Widget key={w.key} open={isOpen(w.key)} onToggle={() => toggle(w.key)} />;
          })}
        </Stack>
      )}
    </Dock>
  );
};
